BaseHandler = App.loadClass "core::reports/BaseHandler"
BaseOutput = App.loadClass "core::reports/BaseOutput"
ChartOutput = App.loadClass "core::reports/ChartOutput"

class exports.ReportsNPracticesSubHandler extends BaseHandler
    init: () ->
        @hasPrint       = false
        @parent.dialog.find('.print-btn').hide()
        @sourceUrl      = 'backend/grower/reports/n-practices/output/detail'
        @layoutUrl      = 'backend/grower/reports/n-practices/chart'
        @filterUrl      = 'backend/grower/reports/n-practices/filters'
        @layoutSelector = "#reports_n_practices_tab"

        $('.sidebar_content').find('.view-field-group-button-container').removeClass('hide')
        $('.sidebar_content').find('#view-field-group-button').prop('disabled', true)

        @parent.dialog.find('.npractices-label').removeClass('hide')
        @parent.dialog.find('.npractices-label').clickover
            html: true
            container: '#bs2-container'

        @initFilters()

        @borderWidth = 2
        @hoverBorderWidth = 3
        @fieldGroup = null

    afterLoadLayout: () ->
        super()

    initFilters: () ->
        @disableAllFilterGroups()

        @parent.filters.importGroup
            name: 'N Practices Report Filters'
            display_name: 'Report Filters'
            filters: [
                name: 'report_type'
                display_name: 'Report Type'
                control_type: 'option'
                deletable: false
                values: [
                    { key: 'nbalance', value: 'N Balance' }
                    { key: 'yield', value: 'Yield' }
                ]
                selected_values: [
                    { key: 'nbalance', value: 'N Balance' }
                ]
            ,
                name: 'npractice_years'
                display_name: 'Year'
                control_type: 'dropdown'
            ,
                name: 'crops'
                display_name: 'Crop'
                control_type: 'single_dropdown'
                auto_select_first: true
            ,
                name: 'previous_crops'
                display_name: 'Previous Crop'
                control_type: 'dropdown'
            ,
                name: 'max_distance'
                display_name: 'Distance'
                control_type: 'single_dropdown'
                values: [
                    { key: '50', value: 'Within 50 miles' }
                    { key: '100', value: 'Within 100 miles' }
                    { key: '150', value: 'Within 150 miles' }
                    { key: '200', value: 'Within 200 miles' }
                    { key: '250', value: 'Within 250 miles' }
                    { key: '300', value: 'Within 300 miles' }
                    { key: '350', value: 'Within 350 miles' }
                ]
            ,
                name: 'npractice_operation_sizes'
                display_name: 'Operation Size'
                control_type: 'dropdown'
            ,
                name: 'partners'
                display_name: 'Partner'
                control_type: 'dropdown'
            ,
                name: 'npractice_fields'
                display_name: 'Field'
                control_type: 'dropdown'
            ,
                name: 'npractice_field_groups'
                display_name: 'Field Group'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_by_default_flag: true
                auto_select_only_value: true
                auto_clear_unavailable: true
            ,
                name: 'irrigation_type'
                display_name: 'Irrigation Type'
                control_type: 'option'
                deletable: true
                values: [
                    { key: 'dryland', value: 'Dryland' }
                    { key: 'irrigated', value: 'Irrigated' }
                ]
            ,
                name: 'practices'
                display_name: 'Practice'
                control_type: 'dropdown'
            ,
                name: 'tillage_systems'
                display_name: 'Tillage System'
                control_type: 'dropdown'
            ,
                name: 'nitrogen_rates'
                display_name: 'Nitrogen Rate'
                control_type: 'dropdown'
                values: [
                    { key: '0-50', value: '0 - 50 lbs/ac' }
                    { key: '50-100', value: '50 - 100 lbs/ac' }
                    { key: '100-150', value: '100 - 150 lbs/ac' }
                    { key: '150-200', value: '150 - 200 lbs/ac' }
                    { key: '200-250', value: '200 - 250 lbs/ac' }
                    { key: '250-300', value: '250 - 300 lbs/ac' }
                    { key: '300-350', value: '300 - 350 lbs/ac' }
                ]
            ,
                name: 'primary_nitrogen_sources'
                display_name: 'Primary N Source'
                control_type: 'dropdown'
            ,
                name: 'data_type'
                display_name: 'Mode'
                control_type: 'option'
                deletable: false
                values: [
                    { key: 'live', value: 'My Fields' }
                    { key: 'demo', value: 'Demo' }
                ]
                selected_values: [
                    { key: 'live', value: 'My Fields' }
                ]
            ]

        # left these in since we will almost surely want to enable them in the future since these values may need adjusted as more data comes in
        # @parent.filters.importGroup
        #     name: 'Temporary Filters'
        #     filters: [
        #         name: 'minimum_observation_percent'
        #         display_name: 'Min. Bucket %'
        #         control_type: 'single_dropdown'
        #         deletable: false
        #         values: [
        #             { key: '0', value: '0' }
        #             { key: '0.01', value: '1%' }
        #             { key: '0.02', value: '2%' }
        #             { key: '0.03', value: '3%' }
        #             { key: '0.04', value: '4%' }
        #             { key: '0.05', value: '5%' }
        #             { key: '0.06', value: '6%' }
        #             { key: '0.07', value: '7%' }
        #             { key: '0.08', value: '8%' }
        #             { key: '0.09', value: '9%' }
        #             { key: '0.1', value: '10%' }
        #             { key: '0.11', value: '11%' }
        #             { key: '0.12', value: '12%' }
        #         ]
        #         selected_values: [
        #             { key: '0', value: '0' }
        #         ]
        #     ,
        #         name: 'data_type'
        #         display_name: 'Data type'
        #         control_type: 'option'
        #         deletable: false
        #         values: [
        #             { key: 'auto_enrolled', value: 'Auto Enrolled' }
        #             { key: 'complete', value: 'Complete Only' }
        #         ]
        #         selected_values: [
        #             { key: 'complete', value: 'Auto Enrolled' }
        #         ]
        #     ]


        @setDefaultsAndRun(0, 0, 0, {}, 'up', false)

    destroy: () ->
        @parent.filters.removeGroup 'N Practices Report Filters'
        # @parent.filters.removeGroup 'Temporary Filters'
        @parent.filters.enableGroup "Report Filters"

        @parent.dialog.find('.excel-btn').addClass('hidden')
        @parent.dialog.find('.info-popover').addClass('hide')
        $('.sidebar_content').find('.view-field-group-button-container').addClass('hide')

        super()

    getDataDetail: () =>
        reportType = if @parent.filters.jsonize().filters.report_type[0].key is 'nbalance' then 'N Balance' else 'Yield'

        # Always disable the button  when we're fetching new report output
        $('.sidebar_content').find('#view-field-group-button').prop('disabled', true)
        $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide')

        return $.get('backend/grower/reports/n-practices/output/detail', { query: @filters }).then (data) =>
            $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide')

            if data.status is 'skip'
                # prevent the report from being run without field groups filter
                return

            # display messages related to the report not being unlocked, low power, and low significance
            if data.status is 'error'
                # we want to append all of the error messages returned by SAIO with a myfarms specific message
                @parent.msg.message_writer data.status, "#{data.message} This report will answer more questions as more farmers participate, so please invite those you know to join for free by calling 260-693-7671.  Thanks in advance!"
                return

            result = data.reportData
            data.fieldGroup.field_group = @parent.filters.jsonize().filters.npractice_field_groups[0].value
            @fieldGroup = data.fieldGroup

            # Enable the button once we have report output
            $('.sidebar_content').find('#view-field-group-button').prop('disabled', false)

            records = _.orderBy(result, 'difference', 'desc')

            labels = _.map records, 'practice'
            scores = _.map records, 'difference'
            acres = _.map records, 'acres'

            datasets = [
                {
                    label: reportType
                    data: scores
                    fill: false
                    backgroundColor: '#498fbf'
                    borderColor: '#498fbf'
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                },
                {
                    label: 'Acres'
                    data: acres
                    hidden: true
                }
            ]

            return {
                data:
                    labels: labels
                    datasets: datasets
                options:
                    legend:
                        display: false
            }

    beforeApply: () ->
        filters = @parent.filters.jsonize()
        reportType = @parent.filters.jsonize().filters.report_type?[0].key

        unless @currentOutput? and reportType is @reportType
            xAxes = [
                scaleLabel:
                    display: true
                    labelString: if reportType is 'nbalance' then 'N Balance Change due to each Practice (N lbs/ac)' else 'Yield Gain due to each Practice (bu/ac)'
                    fontSize: 20
                ticks:
                    beginAtZero: true
            ]
            yAxes = [
                scaleLabel:
                    display: false
                maxBarThickness: 50
            ]

            @currentOutput = new ChartOutput this, @parent, @sourceUrl, 'horizontalBar', xAxes, yAxes, {
                tooltips: {
                    callbacks: {
                        title: (items, data) =>
                            return items[0].yLabel + ' (' + data.datasets[1].data[data.labels.indexOf(items[0].yLabel)] + ' ac)'
                    }
                }
            }, @getDataDetail

            @reportType = reportType